import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 非麻瓜漫画韩漫免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2 flex flex-col gap-1">
          {comic.isFree && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              免费
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="px-2 py-0.5 bg-foreground-800/80 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              完结
            </span>
          )}
          {comic.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-background-50 text-sm font-semibold leading-tight line-clamp-2">
            {comic.title}
          </h3>
          <p className="text-background-200/80 text-xs mt-1">
            {comic.status === '已完结'
              ? `${comic.chapters[0]?.title || ''}`
              : `更新至 ${comic.chapters[0]?.title || ''}`}
          </p>
        </div>
      </div>
      <div className="p-3">
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </span>
            {comic.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}